import { useCurrency } from '#bv/lib/currency/CurrencyContext'

type Props = {
  usdTotal: number
  className?: string
}

/** Card/crypto checkout is always billed in USD — show local estimate + charge line. */
export function CheckoutCurrencyNotice({ usdTotal, className = '' }: Props) {
  const { currency, price, formatUsdCharge } = useCurrency()
  const charge = formatUsdCharge(usdTotal)

  if (currency === 'USD') {
    return (
      <p className={`m-0 text-xs leading-relaxed text-[#5a6d8a] ${className}`}>
        You will be charged <strong className="text-[#d4e8ff]">{charge}</strong> at checkout.
      </p>
    )
  }

  const local = price(usdTotal)
  return (
    <div className={className}>
      <p className="m-0 rounded-xl border border-[rgba(0, 191, 255,0.2)] bg-[rgba(0, 191, 255,0.06)] px-3 py-2.5 text-xs leading-relaxed text-[#e8d0e4]">
        <span className="block font-semibold text-[#f0f6ff]">Checkout currency: USD</span>
        <span className="mt-1 block">
          You will be charged <strong className="text-[#d4e8ff]">{charge}</strong>.
          {' '}
          Approx. <strong className="text-[#d4e8ff]">{local.formatted}</strong> at today&apos;s rate
          (display only — your bank may show a different amount).
        </span>
      </p>
    </div>
  )
}
